module.exports = __webpack_public_path__ + "static/img/xh-user-avatar.0d9ab8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/xh-user-avatar.png
// module id = BE3D
// module chunks = 0